import React, { useEffect, useState } from "react";
import { FaUsers, FaPhoneAlt } from "react-icons/fa"; // Icons for admissions and contacts
import SummaryApi from "../../common";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js';
import { Link } from 'react-router-dom';
import img1 from '../../Assets/oakaylogo.png'
import notification from '../../Assets/notification.png'
import events from '../../Assets/events.png'
import exams from '../../Assets/exam.png'
import attendance from '../../Assets/attendence.png'
import { BsThreeDots } from "react-icons/bs";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdClass } from "react-icons/md";
import { BsFillSignIntersectionFill } from "react-icons/bs";
import { RiParentFill } from "react-icons/ri";
import { FaPhoneVolume } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import { FaTransgenderAlt } from "react-icons/fa";
import { MdBloodtype } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import { MdWifiCalling3 } from "react-icons/md";
import { GoNumber } from "react-icons/go";
import { FaRegCalendarAlt } from "react-icons/fa";
import { PiExamFill } from "react-icons/pi";
import { PiExamDuotone } from "react-icons/pi";
import { FaBusAlt } from "react-icons/fa";
import { FaPercent } from "react-icons/fa";
import { Pie } from 'react-chartjs-2';
import { MdKeyboardArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import Calendar from "../../pages/Calendar";
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
const StudentDashboard = () => {
  const [counts, setCounts] = useState({
    total_admissions: 0,
    today_admissions: 0,
    total_contacts: 0,
    today_contacts: 0,
  });
  // Fetch data on component mount
  useEffect(() => {
    fetch(SummaryApi.getCounts.url)
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setCounts(data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching counts:", error);
      });
  }, []);

  const data = {
    labels: ['Students', 'Teachers', 'Parents'],
    datasets: [
      {
        data: [60, 30, 10], // Percentages
        backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56'], // Colors for each segment
        hoverBackgroundColor: ['#36A2EB', '#FF6384', '#FFCE56'],
      },
    ],
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-3">Admin Dashboard</h1>

      <nav className="text-gray-600 mb-4">
        <ol className="flex space-x-2 text-[16px]">
          <li>
            <Link to="/dashboard" className="hover:text-[#ffa404]">
              Home
            </Link>
          </li>
          <li className="text-[#ffa404]">
            <MdKeyboardArrowRight size={25} />
          </li>
          <li className="text-[#ffa404]">
            <Link to="/allStudents" className="hover:text-[#ffa404]">
              Student
            </Link>
          </li>
        </ol>
      </nav>

      <div className="flex row gap-5 w-full mt-[3%] mb-3">
        <div className="bg-white shadow-md rounded-lg p-6 h-[72vh] w-[28%]">

          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">About Me</h2>
            <button className="text-gray-300 text-xl"><BsThreeDots size={30} /></button>
          </div>

          <div className="flex items-center space-x-4">

            <div className="w-16 h-16 overflow-hidden rounded-full">
              <img
                src={img1}
                alt="Student"
                className="w-24 h-26 rounded-full mb-4 "
              />
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-800">John Doe</h3>
              <p>Attendance: <span className='text-green-500'>Present</span></p>
            </div>
          </div>

          <div className='mt-3 ml-[5%]'>
            {/* Class */}
            <div className="flex items-center mb-5 text-[16px]">
              <MdClass className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Class</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">10th Class</span>
              </p>
            </div>

            {/* Section */}
            <div className="flex items-center mb-5 ">
              <BsFillSignIntersectionFill className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Section</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">A</span>
              </p>
            </div>

            {/* Father's Name */}
            <div className="flex items-center mb-5">
              <RiParentFill className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Father's Name</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">ABC</span>
              </p>
            </div>

            {/* Mother's Name */}
            <div className="flex items-center mb-5">
              <RiParentFill className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Mother's Name</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">BCDF</span>
              </p>
            </div>

            {/* Mobile Number */}
            <div className="flex items-center mb-5">
              <FaPhoneVolume className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Mobile Number</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">9876543210</span>
              </p>
            </div>

            {/* Parent Number */}
            <div className="flex items-center mb-5">
              <MdWifiCalling3 className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Parent Number</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">9876543210</span>
              </p>
            </div>

            {/* Email */}
            <div className="flex items-center mb-5">
              <MdEmail className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Email</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">john.doe@example.com</span>
              </p>
            </div>

            {/* Gender */}
            <div className="flex items-center mb-5">
              <FaTransgenderAlt className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Gender</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">Male</span>
              </p>
            </div>

            {/* Blood Group */}
            <div className="flex items-center mb-5">
              <MdBloodtype className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Blood Group</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">O+</span>
              </p>
            </div>

            {/* Address */}
            <div className="flex items-center mb-5">
              <FaLocationDot className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Address</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">Kannuru, Vijayawada</span>
              </p>
            </div>

            {/* Aadhar Number */}
            <div className="flex items-center mb-5">
              <GoNumber className="mr-2 text-gray-700" />
              <p className="flex w-full">
                <span className="w-[30%] text-left">Aadhar Number</span>
                <span className="w-[10%] text-center">:</span>
                <span className="w-[60%] text-left font-semibold">1234 5678 9101</span>
              </p>
            </div>
          </div>
        </div>
        <div className=" w-[70%]">
          <div className="grid grid-cols-4 gap-6 mb-5">
            <div className="bg-[#fff] p-4 rounded-lg shadow-md">
              <div className='flex row justify-between items-center'>
                <img src={notification}/>
                {/* <FaPercent size={30} className='' /> */}
                <h3 className="text-lg font-semibold mb-2 ">Notifications</h3>

              </div>

              <div className='flex row justify-between items-center'>
                <p className="text-md mb-2 "></p>
                <p className="text-md  mb-2 text-[#cf395f]">Important!</p>
              </div>
            </div>
            <div className="bg-[#fff] p-4 rounded-lg shadow-md">
              <div className='flex row justify-between items-center'>
                
                {/* <PiExamFill size={38} className='' /> */}
                <img src={events} />
                <h3 className="text-lg font-semibold mb-2 ">Events</h3>
              </div>
              <div className='flex row justify-between items-center'>
                <p className="text-md mb-2 "></p>
                <p className="text-md  mb-2 text-[#2196f3]">New Year</p>
              </div>
            </div>
            <div className="bg-[#fff] p-4 rounded-lg shadow-md">
              <div className='flex row justify-between items-center'>
                
                {/* <PiExamDuotone size={38} className='' /> */}
                <img src={exams}/>
                <h3 className="text-lg font-semibold mb-2 ">Exams</h3>
              </div>
              <div className='flex row justify-between items-center'>
                <p className="text-md mb-2 "></p>
                <p className="text-md  mb-2 text-[#FF10F0]">Final</p>
              </div>
            </div>
            <div className="bg-[#fff] p-4 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold mb-2"></h3>
              <div className='flex row justify-between items-center'>
                
                {/* <FaBusAlt size={35} className='' /> */}
                <img src={attendance}/>
                <h3 className="text-lg font-semibold mb-2 ">Attendance</h3>
              </div>
              <div className='flex row justify-between items-center'>
                <p className="text-md mb-2 "></p>
                <p className="text-md  mb-2 text-[#228B22]">20%</p>
              </div>
            </div>
          </div>
          <div className="bg-[#fff] p-4 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">All Exam Results</h2>

            <div className="flex space-x-16 justify-center items-center mb-6">
              <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100" placeholder="Search by Name" />
              <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100" placeholder="Search by Roll" />
              <input type="text" className="p-2 pl-5 pr-5 rounded bg-gray-100" placeholder="Search by Class" />
              <button className="pl-5 pr-5 p-1 bg-[#ffa404] text-white rounded hover:bg-green-600 text-xl">SEARCH</button>
            </div>
            <table className="table-auto w-full border border-gray-300 border-collapse">
              <thead>
                <tr className="border-b border-gray-300">
                  <th className="p-3 text-left text-gray-600">
                    <input type="checkbox" className="form-check-input" /> ID
                  </th>
                  <th className="p-3 text-left text-gray-600">Exam Name</th>
                  <th className="p-3 text-left text-gray-600">Subject</th>
                  <th className="p-3 text-left text-gray-600">Grade</th>
                  <th className="p-3 text-left text-gray-600">Percent</th>
                  <th className="p-3 text-left text-gray-600">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0021</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">English</td>
                  <td className="p-3">A</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0022</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">English</td>
                  <td className="p-3">A</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0023</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">Chemistry</td>
                  <td className="p-3">A</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>

                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0025</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">Chemistry</td>
                  <td className="p-3">A</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0026</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">Chemistry</td>
                  <td className="p-3">D</td>
                  <td className="p-3">70.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0027</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">English</td>
                  <td className="p-3">C</td>
                  <td className="p-3">80.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0028</label>
                    </div>
                  </td>
                  <td className="p-3">Class Test</td>
                  <td className="p-3">English</td>
                  <td className="p-3">B</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
                <tr className="border-b border-gray-300 even:bg-gray-100 odd:bg-white hover:bg-green-200">
                  <td className="p-3">
                    <div className="form-check flex items-center space-x-2">
                      <input type="checkbox" className="form-check-input" />
                      <label className="form-check-label">#0029</label>
                    </div>
                  </td>
                  <td className="p-3">First Semester</td>
                  <td className="p-3">English</td>
                  <td className="p-3">A</td>
                  <td className="p-3">99.00 > 100</td>
                  <td className="p-3">22/02/2019</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div class="flex space-x-4">
        <div class="bg-white p-4 rounded-lg shadow-md w-1/3">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Attendance</h2>
            <button className="text-gray-300 text-xl"><BsThreeDots size={30} /></button>
          </div>
          <div className="flex justify-center">
            <Pie data={data} type="doughnut" options={{ responsive: true }} />
          </div>
        </div>
        <div class="bg-white p-4 rounded-lg shadow-md w-1/3">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Event Calendar</h2>
            <button className="text-gray-300 text-xl"><BsThreeDots size={30} /></button>
          </div>
          <div className="">
            {/* <h2 className="text-xl font-semibold text-gray-800 mb-4">March 2025</h2> */}
            {/* <div className=" flex text-[#000] text-xl"><MdKeyboardArrowLeft  size={30} /><MdOutlineKeyboardArrowRight   size={30} /></div> */}
            <Calendar />
          </div>
        </div>
        <div class="bg-white p-4 rounded-lg shadow-md w-1/3">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Notifications</h2>
            <button className="text-gray-300 text-xl"><BsThreeDots size={30} /></button>
          </div>
          <div className="overflow-y-auto max-h-[400px] p-2">
            <div className="p-1">
              <button className="bg-[#40dfcd] text-white rounded-2xl p-3 font-semibold ">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#fbd540] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#f939a1] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#40dfcd] text-white rounded-2xl p-3 font-semibold ">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#fbd540] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#f939a1] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#40dfcd] text-white rounded-2xl p-3 font-semibold ">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#fbd540] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            <div className="p-1">
              <button className="bg-[#f939a1] text-white rounded-2xl p-3 font-semibold">16 June, 2019</button>
              <h6 className="font-semibold text-[14px] p-1">Great School manag mene esom tus eleifend lectus sed maximus mi faucibusnting.</h6>
              <p className="p-1">Jennyfar Lopez / <span className="text-gray-300 p-1">5 min ago</span></p>
              <hr className="my-3 border-t-1 border-gray-300" />
            </div>
            
          </div>


        </div>
      </div>


    </div>
  );
};
export default StudentDashboard;